import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cva, VariantProps } from 'class-variance-authority';
import { OmitStylesComponentProps } from '../../types';
import { cn } from '../../utils/cn';

const switchThumbVariants = cva('rocco-switch-thumb', {
    variants: {
        variant: {
            default:
                'pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const SwitchThumb = React.forwardRef<
    React.ElementRef<typeof SwitchPrimitives.Thumb>,
    OmitStylesComponentProps<typeof SwitchPrimitives.Thumb> &
        VariantProps<typeof switchThumbVariants> & { className?: string }
>(({ variant, className, ...props }, ref) => {
    const thumbClass = cn(switchThumbVariants({ variant }), className);
    return (
        <SwitchPrimitives.Thumb ref={ref} className={thumbClass} {...props} />
    );
});

SwitchThumb.displayName = SwitchPrimitives.Thumb.displayName;
